<script lang="ts" setup>
import { BoxProps } from "~/components/ProductBlocks/KeepBuying/Utils/Box.props"

defineProps<BoxProps>()
</script>

<template>
  <div
    class="
      keep-buying-box
      bg-white
      space-y-4
      px-4
      py-6
      md:space-y-6
      md:p-8
      md:shadow-01
    "
  >
    <header class="space-y-3">
      <p class="hyppo-bold md:elephant-bold text-green-main">
        {{ $t("productBlocks.keepBuying.utils.keepBuyingBox.keepBuying") }}
      </p>
      <UtilsMarkdown class="beaver" v-if="!!text" :content="text" />
    </header>

    <GAItem id="continue-buying" :item="products">
      <GAViewItemList> </GAViewItemList>
    </GAItem>

    <ProductTileOverallSearch
      class="block space-y-5"
      v-for="product in products"
      :key="product.title"
      :="product"
      no-button
      long-version
    />

    <UtilsButton
      class="mt-6 block"
      :text="$t('productBlocks.keepBuying.utils.keepBuyingBox.goToTheCart')"
      :path="path"
      fluid
    />
  </div>
</template>
